import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-learner',
  templateUrl: './main-learner.component.html',
  styleUrls: ['./main-learner.component.css']
})
export class MainLearnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
